import {  Action, createAction, props } from '@ngrx/store';


export const CONTRACTITEM = createAction('[contract] item contract',props<{item:any}>());
export const CONTRACTITEMS = createAction('[contract] contracts list',props<{items:any}>());
export const CONTRACTLOAD = createAction('[contract] contracts load',props<{idContract: String}>());
